import { StyleSheet, Platform } from 'react-native';
export const styles = StyleSheet.create({
  container: {
    marginTop: 16,
    marginHorizontal: 16,
  },
  heading: {
    backgroundColor: 'white',
    borderColor: '#E4E7EC',
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    borderWidth: 1,
    paddingTop: 20,
    paddingLeft: 23,
    paddingBottom: 12,
    borderBottomWidth: 0,
    elevation: 20,
    shadowColor: '#98A2B3',
    zIndex: 1,
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.2,
    shadowRadius: 4.65,
  },
  headingWhenEditLimitShown: {
    backgroundColor: 'white',
    borderColor: '#E4E7EC',
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    paddingTop: 20,
    paddingLeft: 23,
    paddingBottom: 8,
  },
  subHeading: {
    backgroundColor: '#FFFFFF',
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    borderTopWidth: 0,
    borderWidth: 1,
    borderColor: '#E4E7EC',
    elevation: 20,
  },
  subHeadingAndroidIOS: {
    backgroundColor: '#FFFFFF',
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    borderTopWidth: 0,
  },
  shimmerImage: {
    height: 50,
    width: 50,
  },
  subHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  imageContainer: {
    paddingLeft: 22,
    paddingTop: 24,
  },
  textContainer: {
    marginLeft: 16,
    paddingTop: 24,
  },
  buttonContainer: {
    width: '100%',
    marginTop: 25,
    paddingLeft: 17,
    paddingBottom: 18,
    paddingRight: 15,
    elevation: 24,
  },
  eligibleText: {
    paddingVertical: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  frameButtonContainer: {
    flexDirection: 'row',
    elevation: 24,
    shadowColor: '#1434CB',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: Platform.OS === 'web' && '0 16px 24px 0 rgba(20, 52, 203, 0.25)',
  },
});
